import {
  fetchQntmBasicSystemConfiguration,
  fetchQntmSingleSystemConfiguration,
  fetchQntmSystemConfigurationComponents,
} from '../api/shop-qntm-system-configuration.api'
import { BasicSystemResponseModel } from '../models/basic-system.model'
import { SystemConfigurationComponentsResponse } from '../models'
import { useShopFetchWithResult } from './use-shop-fetch'

/*
 * Theese Custom Hook have all System Configurator Endpoints.
 * Everything Related to System Configurator, like Power Meters, Main or Additional Components, Basic Component, Transformers and Retrofit Batteries
 */

interface UseShopQntmSystemConfigurationHook {
  getQntmBasicSystemConfiguration: () => Promise<BasicSystemResponseModel | null>
  getQntmSystemConfigurationComponents: (configuratorId: string) => Promise<SystemConfigurationComponentsResponse | null>
  getQntmSingleSystemConfiguration: (configurationId: string) => Promise<BasicSystemResponseModel | null>
}
const useShopQntmSystemConfiguration = (): UseShopQntmSystemConfigurationHook => {
  const shopFetch = useShopFetchWithResult()

  const getQntmBasicSystemConfiguration = async (): Promise<BasicSystemResponseModel | null> => {
    try {
      const response = await fetchQntmBasicSystemConfiguration(shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    }
  }
  const getQntmSystemConfigurationComponents = async (configuratorId: string): Promise<SystemConfigurationComponentsResponse | null> => {
    try {
      const response = await fetchQntmSystemConfigurationComponents(configuratorId, shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    }
  }
  const getQntmSingleSystemConfiguration = async (configuratorId: string): Promise<BasicSystemResponseModel | null> => {
    try {
      const response = await fetchQntmSingleSystemConfiguration(configuratorId, shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    }
  }

  return {
    getQntmSystemConfigurationComponents,
    getQntmBasicSystemConfiguration,
    getQntmSingleSystemConfiguration,
  }
}

export default useShopQntmSystemConfiguration
